let version = require("../../package.json").version;
export const ACCOUNT_APP_URL =
  process.env.REACT_APP_ACCOUNT_APP_URL || "http://localhost:4000 ";
export const SSO_WEB_URL =
  process.env.REACT_APP_SSO_WEB_URL || "http://localhost:3001";
export const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://people-api.qa2.esoko.com:8002/v1";
export const SSO_URL =
  process.env.REACT_APP_SSO_URL ||
  "http://accounts-sso-api.qa.esoko.com:5050/v1";
export const SSO_API =
  process.env.REACT_APP_SSO_API_URL ||
  "http://accounts-sso.qa.esoko.com:5050/api/v2";
export const PUSH_API_URL =
  process.env.REACT_APP_PUSH_API_URL ||
  "http://192.168.3.82:1910/v1" ||
  "http://push-api-dev.esoko.com/v1";
export const REACT_APP_VERSION = version;
export const REACT_APP_COOKIES_DOMAIN =
  process.env.REACT_APP_COOKIES_DOMAIN || window.location.hostname;
export const REACT_APP_NODE_ENV =
  process.env.REACT_APP_NODE_ENV || "development";
export const REACT_INTERCOM_APP_ID =
  process.env.REACT_INTERCOM_APP_ID || "jxm2i8o8";
export const REACT_RECAPTCHA_SECRET_KEY =
  process.env.REACT_RECAPTCHA_SECRET_KEY ||
  "6Le2HWIUAAAAACcBS0_vW-Dxvo7yZ9pbT_tVi9FC";
export const REACT_GOOGLE_MAP_API =
  process.env.REACT_GOOGLE_MAP_API || "AIzaSyCSjXAyUEZPiaycd0AkSlYoW2byopYtdVQ";
export const REACT_RECAPTCHA_SITE_KEY =
  process.env.REACT_RECAPTCHA_SITE_KEY ||
  "6Le2HWIUAAAAAA77C0BjqJSkbarZPuT9Gfc_GGBi";
export const STORAGE_PRFX = process.env.REACT_APP_STORAGE_PREFIX || "esk_";
